import CampusRowComponent from './campus-row-component';

/***
 * The static representation of a single campus/location
 */
const CampusRow = angular
    .module('CampusData.ClientAdmin.CampusRow', [])
    .component('campusRow', CampusRowComponent)
    .name;

export default CampusRow;



// WEBPACK FOOTER //
// ./app/components/client-admin/campus-row/campus-row.js